type SpeedPresetButton = {
  val: number;
  precision?: number;
};

export const SPEED_PRESET_BUTTONS: Array<SpeedPresetButton> = [
  { val: 0.75 },
  { val: 1 },
  { val: 1.1, precision: 3 },
  { val: 1.15, precision: 3 },
  { val: 1.25, precision: 3 },
  { val: 1.5 },
  { val: 1.75, precision: 3 },
  { val: 1.85, precision: 3 },
  { val: 2.5 },
  { val: 4 },
];

const PRESET_RATES: ReadonlyArray<number> = SPEED_PRESET_BUTTONS.map(
  (preset) => preset.val,
);

/**
 * Two decimals is the real resolution of every speed control (the reader steps
 * by 0.05), and rounding there also drops float artifacts like
 * 1.3000000000000003.
 */
export const speedRateKey = (rate: number) => rate.toFixed(2);

/** Display form with trailing zeros trimmed: "1", "1.05", "1.25". */
export const speedRateLabel = (rate: number) =>
  String(Number(speedRateKey(rate)));

/**
 * The presets, plus `rate` itself when it is not one of them — a `<Select>`
 * whose value matches no option renders blank, and one tap of the reader's `+`
 * button is already off-preset.
 */
export const speedRateOptions = (rate: number): ReadonlyArray<number> => {
  if (
    PRESET_RATES.some((preset) => speedRateKey(preset) === speedRateKey(rate))
  ) {
    return PRESET_RATES;
  }
  return [...PRESET_RATES, rate].toSorted((a, b) => a - b);
};
